import {
  CalendarDays,
  Droplets,
  House,
  Info,
  Leaf,
  MapPin,
  Map as MapIcon,
  Sunset,
  TrainFront,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  readonly to: string;
  readonly label: string;
  readonly icon: LucideIcon;
  readonly end: boolean;
}

/** Navigation principale (en-tête desktop, menu mobile). */
export const PRIMARY_NAV: readonly NavItem[] = [
  { to: '/', label: 'Accueil', icon: House, end: true },
  { to: '/transports', label: 'Transports', icon: TrainFront, end: false },
  { to: '/carte', label: 'Carte', icon: MapIcon, end: false },
  { to: '/agenda', label: 'Agenda', icon: CalendarDays, end: false },
  { to: '/lieux', label: 'Lieux', icon: MapPin, end: false },
  { to: '/a-propos', label: 'À propos', icon: Info, end: false },
];

/** Navigation basse mobile : les 5 usages quotidiens (À propos passe dans le menu ☰). */
export const BOTTOM_NAV: readonly NavItem[] = PRIMARY_NAV.filter((item) => item.to !== '/a-propos');

/** Entrées supplémentaires du menu mobile. */
export const SECONDARY_NAV: readonly NavItem[] = [
  { to: '/ciel', label: 'Le ciel d’Ermont', icon: Sunset, end: false },
  { to: '/air', label: 'Qualité de l’air', icon: Leaf, end: false },
  { to: '/eau', label: 'Eau du robinet', icon: Droplets, end: false },
];
